import type { FfprobeOutput } from '../util/ffprobeOutput';

// Sent from renderer to main to request a fresh MessagePort connection.
export const LOCAL_FFMPEG_REQUEST_PORT_CHANNEL = 'local-ffmpeg-request-port';

// Sent from main to renderer carrying the MessagePortMain in event.ports[0].
export const LOCAL_FFMPEG_PORT_CHANNEL = 'local-ffmpeg-port';

// Tag for preload message for port forwarding
export const LOCAL_FFMPEG_PORT_WINDOW_MESSAGE_TYPE = '__mimir-local-ffmpeg-port';

// IPC channel for querying whether system ffmpeg executables are available.
export const LOCAL_FFMPEG_CAPABILITY_CHANNEL = 'local-ffmpeg-capability';

export interface LocalFfmpegInstallation {
  version: string;
  ffmpegPath: string;
  ffprobePath: string;
}

export interface LocalFfmpegPortReply {
  requestId: number;
  available: boolean;
}

export type LocalFfmpegPixelFormat = 'rgba' | 'yuv420p';

export type StreamType = 'nut';

export interface LocalFfmpegNutVideoStreamRequest {
  type: 'nut';
  filePath: string;
  startMs: number;
  width: number;
  height: number;
  pixelFormat: LocalFfmpegPixelFormat;
  includeAudio: boolean;
}

export interface LocalFfmpegNutAudioStreamRequest {
  type: 'nut_audio';
  filePath: string;
  startMs: number;
  sampleRate: number;
}

export type LocalFfmpegStreamRequest =
  | LocalFfmpegNutVideoStreamRequest
  | LocalFfmpegNutAudioStreamRequest;

// Messages sent from the renderer to the main process over the MessagePort.

export interface LocalFfmpegProbeRequest {
  type: 'probe';
  requestId: number;
  filePath: string;
}

export interface LocalFfmpegOpenRequest {
  type: 'open';
  sessionId: number;
  request: LocalFfmpegStreamRequest;
}

export interface LocalFilesFeedMeRequest {
  type: 'feed_me';
  sessionId: number;
  bytes: number;
}

export interface LocalFfmpegCloseRequest {
  type: 'close';
  sessionId: number;
}

export type LocalFfmpegPortRequest =
  | LocalFfmpegProbeRequest
  | LocalFfmpegOpenRequest
  | LocalFilesFeedMeRequest
  | LocalFfmpegCloseRequest;

// Messages sent from the main process to the renderer over the MessagePort.

export interface LocalFfmpegProbeResult {
  type: 'probe_result';
  requestId: number;
  output: FfprobeOutput;
}

export interface LocalFfmpegProbeError {
  type: 'probe_error';
  requestId: number;
  message: string;
}

export interface LocalFfmpegDataResponse {
  type: 'data';
  sessionId: number;
  bytes: Uint8Array;
}

export interface LocalFfmpegEndResponse {
  type: 'end';
  sessionId: number;
}

export interface LocalFfmpegSessionError {
  type: 'session_error';
  sessionId: number;
  message: string;
}

export type LocalFfmpegPortResponse =
  | LocalFfmpegProbeResult
  | LocalFfmpegProbeError
  | LocalFfmpegDataResponse
  | LocalFfmpegEndResponse
  | LocalFfmpegSessionError;

// Preload-context bridge exposed on the context bridge object.
export interface IpcLocalFfmpeg {
  getFfmpeg(): Promise<LocalFfmpegInstallation | null>;
}
